import { Component, input } from '@angular/core';

@Component({
    selector: 'ship-class-title-and-legend',
    templateUrl: './ship-class-title-and-legend.component.html',
    standalone: false
})
export class ShipClassTitleAndLegendComponent {
  hideLegend: boolean = false;
  readonly legendDisplay = input<string>("Legend");
}
